import req from './../../fetch';
import { undocumentedResponse } from './../../utils';
import { AllAPIResponses, CarbonError, RoleType } from './../../index';
const get = async (headers?: Headers): Promise<AllAPIResponses<RoleType[]>> => {
  try {
    const resp = await req.get(`/api/roles`, headers);
    const clone = resp.clone();
    switch (resp.status) {
      case 200:
        return {
          data: (await resp.json()) as RoleType[],
          response: clone,
        };
      case 400:
      case 401:
      case 403:
      case 404:
      case 500:
        return {
          error: (await resp.json()) as CarbonError,
          response: clone,
        };
      default:
        return {
          error: new Error(undocumentedResponse(resp)),
          response: clone,
        };
    }
  } catch (e) {
    return { error: e, response: undefined };
  }
};

export default get;
